import { UPDATE_SEED } from 'client/actions/constants';

/**
 * Reducer for the seed value used by edmSeedRandom utilities.
 *
 * @param {string} state
 * @param {Object} action
 * @return {string}
 */
export const seedReducer = (state = null, action = {}) => {
  if (action.type === UPDATE_SEED) {
    return action.data;
  }
  return state;
};
